import React from 'react';
import UnitCounterAsImage, { EliminatedUnitCounterAsImage, } from '../unit/UnitCounterAsImage.js';
export default function ResultUnitCounter({ unit, isBold }) {
    if (unit.health <= 0) {
        return React.createElement(EliminatedUnitCounterAsImage, { unit: unit, counterSize: 60, isBold: isBold });
    }
    return React.createElement(UnitCounterAsImage, { unit: unit, counterSize: 60, isBold: isBold });
}
